/**
 * 脚本任务属性组件
 * 包含脚本语言选择、脚本内容编辑等功能
 */
import React from 'react';
import { Form, Select, Card } from 'antd';
import { CodeOutlined } from '@ant-design/icons';
import AceEditor from 'react-ace';

// 导入语言模式
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/mode-groovy';
import 'ace-builds/src-noconflict/mode-java';
import 'ace-builds/src-noconflict/mode-sh';

// 导入主题
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-github';

// 导入扩展
import 'ace-builds/src-noconflict/ext-language_tools';

const { Option } = Select;

const ScriptTaskProperties = ({ form }) => {
  const scriptLanguage = Form.useWatch('scriptLanguage', form) || 'javascript';
  const scriptContent = Form.useWatch('script', form) || '';

  // 脚本语言选项
  const scriptLanguageOptions = [
    { value: 'javascript', label: 'JavaScript', mode: 'javascript' },
    { value: 'python', label: 'Python', mode: 'python' },
    { value: 'groovy', label: 'Groovy', mode: 'groovy' },
    { value: 'java', label: 'Java', mode: 'java' },
    { value: 'shell', label: 'Shell', mode: 'sh' }
  ];

  const getCurrentMode = () => {
    const option = scriptLanguageOptions.find(opt => opt.value === scriptLanguage);
    return option ? option.mode : 'javascript';
  };

  return (
    <Card 
      size="small" 
      className="mb-4"
      title={
        <div className="flex items-center space-x-2">
          <CodeOutlined />
          <span>脚本配置</span>
        </div>
      }
    >
      <Form.Item
        label="脚本语言"
        name="scriptLanguage"
        className="mb-3"
        initialValue="javascript"
      >
        <Select placeholder="选择脚本语言">
          {scriptLanguageOptions.map(option => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      </Form.Item>
      
      <Form.Item
        label="脚本内容"
        name="script"
        className="mb-0"
      >
        <div className="border border-gray-300 rounded">
          <AceEditor
            mode={getCurrentMode()}
            theme="github"
            value={scriptContent}
            onChange={(value) => {
              form.setFieldsValue({ script: value });
            }}
            name="script-editor"
            editorProps={{ $blockScrolling: true }}
            setOptions={{
              enableBasicAutocompletion: true,
              enableLiveAutocompletion: true,
              enableSnippets: true,
              showLineNumbers: true,
              tabSize: 2,
              fontSize: 14,
              wrap: true
            }}
            width="100%"
            height="300px"
            placeholder={`请输入${scriptLanguageOptions.find(opt => opt.value === scriptLanguage)?.label || 'JavaScript'}脚本代码...`}
          />
        </div>
      </Form.Item>
      
      <div className="mt-2 text-xs text-gray-500">
        <div>• 脚本将在流程执行时运行</div>
        <div>• 可以使用内置变量和函数</div>
        <div>• 请确保脚本语法正确</div>
      </div>
    </Card>
  );
};

export default ScriptTaskProperties;